import(/* webpackMode: "eager" */ "/vercel/path0/app/(global)/error.tsx");
